module.exports = __webpack_public_path__ + "media/images/case-studies/South_East_Food_Hub-39b9529f2886b4c949f97b889ac8e0e0.png";